
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";
import { ptBR, enUS } from "date-fns/locale";
import { Clock } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { useTranslations } from "@/hooks/useTranslations";

interface UpcomingEventsProps {
  events: any[];
}

export const UpcomingEvents = ({ events }: UpcomingEventsProps) => {
  const { language } = useLanguage();
  const { t } = useTranslations("student");
  const dateLocale = language === 'pt' ? ptBR : enUS;
  
  return (
    <Card className="shadow-md border border-slate-100 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl font-semibold">{t("overview.tables.upcomingEvents")}</CardTitle>
      </CardHeader>
      <CardContent>
        {events && events.length > 0 ? (
          <div className="space-y-4">
            {events.map((event) => (
              <div key={event.id} className="bg-slate-50/70 dark:bg-gray-700/50 p-4 rounded-lg border border-slate-100 dark:border-gray-600">
                <div className="font-medium text-slate-800 dark:text-slate-100">{event.title || "Aula agendada"}</div>
                <div className="text-sm flex items-center mt-1 text-slate-500 dark:text-slate-300">
                  <Clock className="h-3 w-3 mr-1 inline" />
                  {format(new Date(event.start_time), "EEEE, dd 'de' MMMM, HH:mm", {
                    locale: dateLocale,
                  })}
                </div>
                <div className="mt-2 flex justify-between items-center">
                  <span className="text-sm text-slate-500 dark:text-slate-300">
                    {event.student_name}
                  </span>
                  <span className="bg-flame/10 text-flame text-xs px-2 py-1 rounded-full">
                    {event.event_type === 'assessment' 
                      ? t("overview.tables.assessment") 
                      : t("overview.tables.training")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center py-8 text-slate-500 dark:text-slate-400">
            {t("overview.tables.noUpcomingEvents")}
          </p>
        )}
      </CardContent>
    </Card>
  );
};
